//项目入口文件
import React from 'react'
import ReactDom from 'react-dom'
import App from './App'
import { ConfigProvider } from "antd"
import zhCN from 'antd/lib/locale/zh_CN';
import "antd/dist/antd.less"
import 'moment/locale/zh-cn';
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from "react-redux"
import persistStore from './redux/store'
const { store, persistor } = persistStore
ReactDom.render(
    <Provider store={store}>
         <PersistGate persistor={persistor}>
        <ConfigProvider locale={zhCN}><App /></ConfigProvider>
        </PersistGate>
    </Provider>
    , document.getElementById('root'))